import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../../core'
import * as epic from '../epic'

export const RESOURCE = {
  payload: {
    canBeOptional: true,
    context: core.dms.models.Attribute.Id.Context.from({
      context: epic.RESOURCE.payload.dimension.partialId,
      partialId: epic.RESOURCE.payload.partialId,
      type: core.dms.models.Type.Entity,
    }),
    description: 'The Jira epic priority.',
    isOptional: true,
    name: 'Priority',
    partialId: PartialId.Standard.create('priority'),
    type: core.common.value.types.Intrinsic.Text,
  },
  type: core.quiver.Resource.Type.DmsAttribute,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsAttribute>
